import { bodiesOverlap } from '../geom'
import { moveFallingBody } from './body'
import { hit } from './hit'
import type { TrapItem } from './types'

/**
 * Trip Wire: a trap dropped `dropBehindPx` behind the owner's back edge (its left edge sits
 * there) at the owner's feet. It falls to the first solid or platform below and waits; the first
 * player who overlaps it and can be hit is stunned and the trap is gone. The owner is ignored for
 * `ownerGraceTicks`.
 */
export const tripWire: TrapItem = {
  id: 'trip_wire',
  use(world, i) {
    const p = world.players[i]!
    const tw = world.cfg.items.tripWire
    world.traps.push({
      id: world.nextId++,
      kind: 'trip_wire',
      owner: i,
      x: p.x - tw.dropBehindPx,
      y: p.y,
      w: tw.widthPx,
      h: tw.heightPx,
      vy: 0,
      grounded: p.grounded,
      ownerSafeUntil: world.tick + tw.ownerGraceTicks,
      expiresAtTick: world.tick + tw.lifetimeTicks,
    })
  },
  update(world, t, events) {
    if (world.tick >= t.expiresAtTick) return false
    moveFallingBody(world, t, 0)
    if (t.y > world.track.killY) return false
    const { stunTicks } = world.cfg.items.tripWire
    for (let i = 0; i < world.players.length; i++) {
      if (i === t.owner && world.tick < t.ownerSafeUntil) continue
      if (!bodiesOverlap(world.players[i]!, t)) continue
      if (hit(world, i, 'trip_wire', stunTicks, events, t.owner)) return false
    }
    return true
  },
}
